var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92237 0L5.9228 9.73298L3.0297 11.254C2.68344 11.436 2.25516 11.3029 2.07312 10.9566C2.00063 10.8187 1.97561 10.6608 2.00194 10.5073L2.55448 7.28574L0.213909 5.00425C-0.0662255 4.73119 -0.0719575 4.28273 0.201106 4.0026C0.309841 3.89105 0.452317 3.81845 0.606477 3.79605L3.84106 3.32604L5.28762 0.395007C5.41085 0.145298 5.66158 0.00035706 5.92237 0Z",
    fill: "#FD7E14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23633 0.0733032C6.37602 0.142245 6.48909 0.255315 6.55803 0.395007L8.00458 3.32604L11.2392 3.79605C11.6263 3.85231 11.8945 4.21175 11.8383 4.59888C11.8159 4.75304 11.7433 4.89552 11.6317 5.00425L9.29117 7.28574L9.8437 10.5073C9.90983 10.8928 9.65088 11.259 9.2653 11.3251C9.11177 11.3515 8.95383 11.3265 8.81595 11.254L5.92284 9.73298L5.92224 9.17019e-07C6.02788 -0.000169403 6.13518 0.0233825 6.23633 0.0733032Z",
    fill: "#FD7E14"
  })));
};
export default SvgStar;